import { render, staticRenderFns } from "./RepeatContentSample.vue?vue&type=template&id=137147c0&"
import script from "./RepeatContentSample.vue?vue&type=script&lang=js&"
export * from "./RepeatContentSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports